import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../../commons/header/header.component';
import { FooterComponent } from '../../commons/footer/footer.component';
import { SocketService } from '../../services/socket-service/socket.service';
import { UserService } from '../../services/user-service/user.service';
import { IEventAuth } from '../../models/models.interface';

@Component({
  selector: 'app-user-layout',
  imports: [RouterOutlet, HeaderComponent,FooterComponent],
  templateUrl: './user-layout.component.html',
  styleUrl: './user-layout.component.scss'
})
export class UserLayoutComponent implements OnInit{

  cartCount: number = 0;

  constructor(private socket: SocketService, private userService: UserService) { }

  ngOnInit(): void {

    setTimeout(() =>{
      const token = this.userService.getUserState().token?.toString() || '';
      if(!token) return;
      this.socket.emit<IEventAuth>('client-emit-cart-user', { token: token});
    }, 2000);

    this.userService.state$.subscribe((state) => {
      console.log("User state in user header:", state);

      if(state.isAuthenticated && state.roles.includes('user') && state.token) {
        console.log(`listen at: server-emit-cart-user=${state.userData?.sub}`);

        this.socket.listen<number>(`server-emit-cart-user=${state.userData?.sub}`).subscribe((data) => {
          console.log("cart socket:",data);
          this.cartCount = data;
        });

        this.socket.emit<IEventAuth>('client-emit-cart-user', { token: state.token });
      }
    });

  }

}
